import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { StepLayout } from 'components/StepLayout/StepLayout';
import { SelectCategoryStepOptions } from './components/SelectCategoryStepOptions';
import { useAppStore } from 'stores/state';
import { biEvents } from 'api/bi-events';
import { BI_ACTION_NAME, BI_STEP_NAME } from 'config/bi-events';
import { StepId } from 'config/flow';

export const SelectCategoryStep: FC = () => {
  const { t } = useTranslation();

  const category = useAppStore((state) => state.category);

  return (
    <StepLayout
      nextButtonProps={{ label: t('select-category-step.actions.next-button'), disabled: !category }}
      description={t('select-category-step.description')}
      title={t('select-category-step.title')}
      onNext={() => {
        biEvents.actionClicked({
          screenName: BI_STEP_NAME[StepId.SelectCategory],
          action: BI_ACTION_NAME.NEXT,
          value: category,
        });
      }}
    >
      <SelectCategoryStepOptions />
    </StepLayout>
  );
};
